import { initBrokerageListing } from './brokerage.js';
import './shop-by.js';

initBrokerageListing({ jsonSuffix: '&json', name: 'category' });
